import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  public platformId: string | undefined;
  public userId: string | undefined;

  enterTiktok: any | undefined;
  enterInstagram: any | undefined;
  enterYoutube: any | undefined;

  constructor(
    private http: HttpClient
  ) { }

  createTikTokAccountTikApi(body: CreateTikTokAccountTikApiIn) {
    console.log('Create TikTok account TikApi ---->');
    console.log('Body: ', body);
    return this.http.post<any>(`${environment.api.baseUrl}/tiktok-account/create-tikapi`, body, { headers: new HttpHeaders().set('Content-Type', 'application/json') });
  }

  createInstagramAccount(body: CreateTikTokAccountTikApiIn) {
    console.log('Create Instagram account ---->');
    console.log('Body: ', body);
    return this.http.post<any>(`${environment.api.baseUrl}/instagram-account/create-apify`, body, { headers: new HttpHeaders().set('Content-Type', 'application/json') });
  }

  createYoutubeAccount(body: CreateYoutubeAccountIn) {
    console.log('🧩🧩🧩 Create YouTube account - body 🧩🧩🧩 ', body);
    return this.http.post<any>(
      `${environment.api.baseUrl}/youtube-account/create-youtube`,
      body,
      { headers: new HttpHeaders().set('Content-Type', 'application/json') }
    );
  }
}

export interface CreateTikTokAccountTikApiIn {
  externalId: string;
  businessId: string;
  handle: string;
}

export interface CreateYoutubeAccountIn {
  externalId: string;
  businessId: string;
  channelIdOrHandle: string;
}
